import { Component, inject } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolIconComponent } from '../../core/sol-icon/sol-icon.component';
import { SolIcon } from '@sol/icons';
import { SolButtonComponent } from '../../core/sol-button/sol-button.component';
import { NotificationService } from '../../../services/notification.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { SolButtonType } from '../../../models/core/sol-button';
import { SolNotificationsState } from './sol-notifications.state';

@Component({
  selector: 'sol-notifications',
  imports: [SolIconComponent, SolButtonComponent, TranslatePipe],
  templateUrl: './sol-notifications.component.html',
})
export class SolNotificationsComponent extends AbstractComponent<SolNotificationsState> {
  protected readonly SolIcon = SolIcon;
  protected readonly SolButtonType = SolButtonType;

  // Dependencies
  private readonly notificationService = inject(NotificationService);

  // Computed
  protected notifications$ = this.compute(state => state.notifications);

  constructor() {
    super(SolNotificationsState.of());

    this.notificationService.watch(state => this.update(s => s.withNotifications(state.notifications)));
  }

  public doAction(id: string) {
    this.notificationService.doAction(id);
  }

  public close(id: string) {
    this.notificationService.close(id);
  }
}
